import { CanLoad, Route, Router, UrlSegment } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { map, take } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserAccessLevel } from '../core/services/user.service';
import { UserState } from '../core/reducers/auth.reducer';

@Injectable({
  providedIn: 'root',
})
export class SysadminGuard implements CanLoad {
  constructor(
    private store: Store<{ user: UserState }>,
    private router: Router,
  ) {}

  canLoad(
    route: Route,
    segments: UrlSegment[],
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.store.pipe(
      select((state) => state.user),
      take(1),
      map((userState) => {
        if (!userState.isAuthChecked || !userState.isAuthenticated) {
          this.router.navigate(['/auth']);
          return false;
        }

        const accessLevel =
          userState.user?.access_level_id ?? UserAccessLevel.GUEST;

        // Module-load floor lowered to GLOBAL_ADMIN (proposal §12 Option A);
        // each child re-asserts its own minimum via MinAccessLevelGuard.
        if (accessLevel >= UserAccessLevel.GLOBAL_ADMIN) {
          return true;
        }

        this.router.navigate(['/']);
        return false;
      }),
    );
  }
}
